/**
 * A value that carries an average: either a plain number (scatter rows) or an object
 * with min/avg/max (variance rows).
 */
type AverageValue = number | { avg?: number | null } | null | undefined

export interface OpportunityAreaRow {
  Importance?: AverageValue
  Development?: AverageValue
}

/**
 * An opportunity area is a knowhow area rated important (>= 4) but underdeveloped (<= 4).
 * Works with both scatter rows (plain numbers) and variance rows (min/avg/max objects).
 */
export function isOpportunityArea (row: OpportunityAreaRow): boolean {
  const importance = averageOf(row.Importance)
  const development = averageOf(row.Development)
  if (importance === undefined || development === undefined) {
    return false
  }
  return importance >= 4 && development <= 4
}

function averageOf (value: AverageValue): number | undefined {
  if (typeof value === 'number') {
    return value
  }
  if (value && typeof value === 'object' && typeof value.avg === 'number') {
    return value.avg
  }
  return undefined
}
